/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AppointmentExchangeStatus = {
    Open: 'Open',
    Accepted: 'Accepted',
    Withdrawn: 'Withdrawn'
} as const;
export type AppointmentExchangeStatus = typeof AppointmentExchangeStatus[keyof typeof AppointmentExchangeStatus];


export function instanceOfAppointmentExchangeStatus(value: any): boolean {
    for (const key in AppointmentExchangeStatus) {
        if (Object.prototype.hasOwnProperty.call(AppointmentExchangeStatus, key)) {
            if (AppointmentExchangeStatus[key as keyof typeof AppointmentExchangeStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AppointmentExchangeStatusFromJSON(json: any): AppointmentExchangeStatus {
    return AppointmentExchangeStatusFromJSONTyped(json, false);
}

export function AppointmentExchangeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentExchangeStatus {
    return json as AppointmentExchangeStatus;
}

export function AppointmentExchangeStatusToJSON(value?: AppointmentExchangeStatus | null): any {
    return value as any;
}

export function AppointmentExchangeStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AppointmentExchangeStatus {
    return value as AppointmentExchangeStatus;
}

